
import { useCallback, useRef } from 'react'
import debounce from 'lodash.debounce'

const useDebouncedCallback = (callback, delay = 250) => {
  const callbackRef = useRef()
  callbackRef.current = callback
  return useCallback(debounce(
    (...args) => callbackRef.current(...args), delay
  ), [])
}

export default useDebouncedCallback
